import { useState, useEffect } from "react";
import { api } from "../api";

const TIPI_CLIENTE = ["DOM", "AZ", "PA"];
const TIPI_CLIENTE_LABEL = { DOM: "Domestico", AZ: "Aziendale", PA: "Pubblica Amm." };
const UNITA_LABEL = { mese: "/mese", anno: "/anno", una_tantum: "una tantum" };
const fmt = (n) => n ? Number(n).toFixed(2).replace(".", ",") + " €" : "—";

// ── Modale listino per tipo cliente ──────────────────────────────────────────
function ModaleListino({ servizio, onClose }) {
  const [listino, setListino] = useState({});
  const [saving, setSaving]   = useState(null);
  const [ok, setOk]           = useState(null);

  useEffect(() => {
    api.getListino(servizio.id).then(rows => {
      const map = {};
      for (const r of rows) map[r.tipo_cliente] = r;
      // Assicura che esistano tutti e 3 i tipi
      for (const tc of TIPI_CLIENTE) {
        if (!map[tc]) map[tc] = { tipo_cliente: tc, attivo: false, prezzo_mensile: 0, prezzo_attivazione: 0, prezzo_vendita: 0, prezzo_noleggio: 0, prezzo_riscatto: 0, durata_noleggio_mesi: 24, note: "" };
      }
      setListino(map);
    }).catch(console.error);
  }, [servizio.id]);

  const salva = async (tc) => {
    setSaving(tc); setOk(null);
    try {
      await api.salvaListino(servizio.id, tc, listino[tc]);
      setOk(tc);
    } catch (e) { alert(e.message); }
    setSaving(null);
  };

  const upd = (tc, campo, val) => setListino(prev => ({ ...prev, [tc]: { ...prev[tc], [campo]: val } }));

  const isBene = servizio.tipo_prodotto === "bene";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" style={{ maxWidth: 700 }} onClick={e => e.stopPropagation()}>
        <h2 className="card-title">💰 Listino — {servizio.nome}</h2>
        <p style={{ fontSize: 12, color: "#64748b", marginBottom: 20 }}>
          Configura prezzi e disponibilità per ogni tipo cliente.
        </p>

        {TIPI_CLIENTE.map(tc => {
          const r = listino[tc] || {};
          return (
            <div key={tc} style={{ border: "1.5px solid #e2e8f0", borderRadius: 10, padding: 16, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <input type="checkbox" checked={!!r.attivo}
                    onChange={e => upd(tc, "attivo", e.target.checked)} />
                  <span style={{ fontWeight: 700, fontSize: 14 }}>{TIPI_CLIENTE_LABEL[tc]}</span>
                </label>
                {ok === tc && <span style={{ fontSize: 11, color: "#15803d" }}>✅ Salvato</span>}
              </div>

              {r.attivo && (
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Nome alternativo</label>
                    <input className="form-input" value={r.nome_override || ""}
                      onChange={e => upd(tc, "nome_override", e.target.value)}
                      placeholder={servizio.nome} />
                  </div>
                  {servizio.unita === "mese" && (
                    <div className="form-group">
                      <label className="form-label">Canone mensile €</label>
                      <input className="form-input" type="number" step="0.01" value={r.prezzo_mensile || ""}
                        onChange={e => upd(tc, "prezzo_mensile", parseFloat(e.target.value) || 0)} />
                    </div>
                  )}
                  <div className="form-group">
                    <label className="form-label">Costo attivazione € {tc === "DOM" ? "(IVA incl.)" : "(IVA escl.)"}</label>
                    <input className="form-input" type="number" step="0.01" value={r.prezzo_attivazione || ""}
                      onChange={e => upd(tc, "prezzo_attivazione", parseFloat(e.target.value) || 0)} />
                  </div>
                  {isBene && (<>
                    <div className="form-group">
                      <label className="form-label">Prezzo vendita €</label>
                      <input className="form-input" type="number" step="0.01" value={r.prezzo_vendita || ""}
                        onChange={e => upd(tc, "prezzo_vendita", parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Canone noleggio €/mese</label>
                      <input className="form-input" type="number" step="0.01" value={r.prezzo_noleggio || ""}
                        onChange={e => upd(tc, "prezzo_noleggio", parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Prezzo riscatto €</label>
                      <input className="form-input" type="number" step="0.01" value={r.prezzo_riscatto || ""}
                        onChange={e => upd(tc, "prezzo_riscatto", parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Durata noleggio (mesi)</label>
                      <select className="form-input" value={r.durata_noleggio_mesi || 24}
                        onChange={e => upd(tc, "durata_noleggio_mesi", parseInt(e.target.value))}>
                        {[12, 24, 36, 48, 60].map(m => <option key={m} value={m}>{m} mesi</option>)}
                      </select>
                    </div>
                  </>)}
                  <div className="form-group span-2">
                    <label className="form-label">Note listino</label>
                    <input className="form-input" value={r.note || ""}
                      onChange={e => upd(tc, "note", e.target.value)}
                      placeholder="Es. Disponibile solo in copertura fibra" />
                  </div>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                <button className="btn btn-primary" style={{ fontSize: 12, padding: "6px 16px" }}
                  onClick={() => salva(tc)} disabled={saving === tc}>
                  {saving === tc ? "Salvataggio..." : "💾 Salva"}
                </button>
              </div>
            </div>
          );
        })}

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
          <button className="btn btn-ghost" onClick={onClose}>Chiudi</button>
        </div>
      </div>
    </div>
  );
}

// ── Modale nuovo/modifica servizio ────────────────────────────────────────────
function ModaleServizio({ servizio, categoriaId, onSalva, onClose }) {
  const vuoto = { categoria_id: categoriaId, nome: "", descrizione: "", tipo_prodotto: "servizio", unita: "mese", attivo: true };
  const [form, setForm] = useState(servizio || vuoto);
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    setSaving(true);
    try {
      if (servizio) await api.modificaServizio(servizio.id, form);
      else await api.creaServizio(form);
      onSalva();
    } catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <h2 className="card-title">{servizio ? "Modifica servizio" : "Nuovo servizio"}</h2>
        <div className="form-grid">
          <div className="form-group span-2">
            <label className="form-label">Nome *</label>
            <input className="form-input" value={form.nome}
              onChange={e => setForm({...form, nome: e.target.value})} placeholder="Es. Fibra FTTH Casa 1Gbps" />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Descrizione</label>
            <textarea className="form-input" rows={2} value={form.descrizione || ""}
              onChange={e => setForm({...form, descrizione: e.target.value})}
              placeholder="Descrizione mostrata nel wizard" />
          </div>
          <div className="form-group">
            <label className="form-label">Tipo prodotto</label>
            <select className="form-input" value={form.tipo_prodotto}
              onChange={e => setForm({...form, tipo_prodotto: e.target.value})}>
              <option value="servizio">Servizio</option>
              <option value="bene">Bene (hardware)</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Unità</label>
            <select className="form-input" value={form.unita}
              onChange={e => setForm({...form, unita: e.target.value})}>
              <option value="mese">Mensile</option>
              <option value="anno">Annuale</option>
              <option value="una_tantum">Una tantum</option>
            </select>
          </div>
        </div>
        <div className="step-actions">
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" onClick={salva} disabled={saving || !form.nome}>
            {saving ? "Salvataggio..." : "Salva"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modale nuova categoria ────────────────────────────────────────────────────
function ModaleCategoria({ onSalva, onClose }) {
  const [form, setForm] = useState({ nome: "", icona: "📦", descrizione: "", label_step: "" });
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    setSaving(true);
    try { await api.creaCategoria(form); onSalva(); }
    catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <h2 className="card-title">Nuova categoria</h2>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Icona (emoji)</label>
            <input className="form-input" value={form.icona}
              onChange={e => setForm({...form, icona: e.target.value})} style={{ fontSize: 20, textAlign: "center" }} />
          </div>
          <div className="form-group">
            <label className="form-label">Nome categoria *</label>
            <input className="form-input" value={form.nome}
              onChange={e => setForm({...form, nome: e.target.value})} placeholder="Es. Servizi Energia" />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Label nello step del wizard *</label>
            <input className="form-input" value={form.label_step}
              onChange={e => setForm({...form, label_step: e.target.value})} placeholder="Es. Energia" />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Descrizione (mostrata nel wizard)</label>
            <textarea className="form-input" rows={2} value={form.descrizione}
              onChange={e => setForm({...form, descrizione: e.target.value})}
              placeholder="Breve descrizione della categoria mostrata al venditore" />
          </div>
        </div>
        <div className="step-actions">
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" onClick={salva} disabled={saving || !form.nome || !form.label_step}>
            {saving ? "Salvataggio..." : "Crea categoria"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Componente principale ────────────────────────────────────────────────────
export default function Catalogo() {
  const [categorie, setCategorie] = useState([]);
  const [servizi, setServizi]     = useState([]);
  const [loading, setLoading]     = useState(true);
  const [catAttiva, setCatAttiva] = useState(null);
  const [modaleListino, setModaleListino]   = useState(null);
  const [modaleServizio, setModaleServizio] = useState(null);
  const [modaleCategoria, setModaleCategoria] = useState(false);

  const carica = async () => {
    setLoading(true);
    try {
      const cats = await api.getCategorie();
      setCategorie(cats);
      if (!catAttiva && cats.length) setCatAttiva(cats[0].id);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const caricaServizi = async (catId) => {
    try {
      const s = await api.getServizi({ categoria_id: catId });
      setServizi(s);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { carica(); }, []);
  useEffect(() => { if (catAttiva) caricaServizi(catAttiva); }, [catAttiva]);

  const toggleCatAttiva = async (id) => {
    const cat = categorie.find(c => c.id === id);
    if (!cat) return;
    try {
      await api.modificaCategoria(id, { attivo: !cat.attivo });
      carica();
    } catch (e) { alert(e.message); }
  };

  const eliminaServizio = async (id) => {
    if (!window.confirm("Eliminare questo servizio?")) return;
    try { await api.eliminaServizio(id); caricaServizi(catAttiva); }
    catch (e) { alert(e.message); }
  };

  const catCorrente = categorie.find(c => c.id === catAttiva);

  return (
    <div className="page">
      <div className="page-header">
        <h1>Catalogo servizi</h1>
        <button className="btn btn-primary" onClick={() => setModaleCategoria(true)}>+ Nuova categoria</button>
      </div>

      {loading && <div className="loading">Caricamento...</div>}

      <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", gap: 20 }}>

        {/* Sidebar categorie */}
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          {categorie.map(cat => (
            <div key={cat.id} onClick={() => setCatAttiva(cat.id)} style={{
              padding: "12px 16px", cursor: "pointer", borderBottom: "1px solid #f1f5f9",
              background: catAttiva === cat.id ? "#eff6ff" : "white",
              borderLeft: catAttiva === cat.id ? "3px solid #0f2850" : "3px solid transparent",
              opacity: cat.attivo ? 1 : 0.5,
            }}>
              <div style={{ fontSize: 13, fontWeight: catAttiva === cat.id ? 700 : 500 }}>
                {cat.icona} {cat.nome}
              </div>
              <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>
                {cat.num_servizi} servizi · {cat.label_step}
              </div>
              <div style={{ display: "flex", gap: 6, marginTop: 6 }} onClick={e => e.stopPropagation()}>
                <button className="btn-icon" title={cat.attivo ? "Disattiva" : "Attiva"}
                  onClick={() => toggleCatAttiva(cat.id)}>
                  {cat.attivo ? "✅" : "⬜"}
                </button>
                {!cat.sistema && (
                  <button className="btn-icon" title="Elimina"
                    onClick={async () => {
                      if (!window.confirm("Eliminare la categoria e tutti i suoi servizi?")) return;
                      try { await api.eliminaCategoria(cat.id); carica(); } catch (e) { alert(e.message); }
                    }}>🗑</button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Servizi della categoria selezionata */}
        <div>
          {catCorrente && (
            <div className="card" style={{ marginBottom: 12, padding: "14px 20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700 }}>{catCorrente.icona} {catCorrente.nome}</div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{catCorrente.descrizione}</div>
                </div>
                <button className="btn btn-primary" style={{ fontSize: 12 }}
                  onClick={() => setModaleServizio({ isNuovo: true })}>
                  + Nuovo servizio
                </button>
              </div>
            </div>
          )}

          {servizi.length === 0 && !loading && (
            <div className="empty-state">
              <div style={{ fontSize: 36 }}>📦</div>
              <div>Nessun servizio in questa categoria</div>
              <button className="btn btn-primary" onClick={() => setModaleServizio({ isNuovo: true })}>
                Aggiungi il primo
              </button>
            </div>
          )}

          {servizi.map(s => (
            <div key={s.id} className="card" style={{ marginBottom: 8, padding: "14px 20px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>
                    {s.nome}
                    <span style={{ marginLeft: 8, fontSize: 10, background: s.tipo_prodotto === "bene" ? "#fef3c7" : "#eff6ff", color: s.tipo_prodotto === "bene" ? "#92400e" : "#1d4ed8", padding: "1px 6px", borderRadius: 6, fontWeight: 700 }}>
                      {s.tipo_prodotto === "bene" ? "Bene" : "Servizio"}
                    </span>
                    <span style={{ marginLeft: 6, fontSize: 10, color: "#94a3b8" }}>{UNITA_LABEL[s.unita]}</span>
                  </div>
                  {s.descrizione && <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>{s.descrizione}</div>}
                  {/* Mini riepilogo listino */}
                  <div style={{ display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
                    {TIPI_CLIENTE.map(tc => {
                      const l = s.listino_per_tipo?.[tc];
                      return (
                        <span key={tc} style={{
                          fontSize: 10, padding: "2px 8px", borderRadius: 8,
                          background: "#f1f5f9", color: "#475569"
                        }}>
                          {tc}: {l?.attivo ? "✅" : "❌"}
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className="btn btn-ghost" style={{ fontSize: 11, padding: "4px 12px" }}
                    onClick={() => setModaleListino(s)}>
                    💰 Listino
                  </button>
                  <button className="btn-icon" onClick={() => setModaleServizio({ isNuovo: false, servizio: s })}>✏️</button>
                  <button className="btn-icon" onClick={() => eliminaServizio(s.id)}>🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modali */}
      {modaleListino && (
        <ModaleListino servizio={modaleListino} onClose={() => setModaleListino(null)} />
      )}
      {modaleServizio && (
        <ModaleServizio
          servizio={modaleServizio.isNuovo ? null : modaleServizio.servizio}
          categoriaId={catAttiva}
          onSalva={() => { setModaleServizio(null); caricaServizi(catAttiva); }}
          onClose={() => setModaleServizio(null)} />
      )}
      {modaleCategoria && (
        <ModaleCategoria
          onSalva={() => { setModaleCategoria(false); carica(); }}
          onClose={() => setModaleCategoria(false)} />
      )}
    </div>
  );
}
